import React, { useEffect } from "react";

import LandingHeader from "../header";

import "./cookiePolicy.css";
import Footer from "../footer";

function CookiePolicy() {
  // Scrolls to the top of the page when the component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="cookie-policy-wrapper">

      {/* Website Header */}
      <div className="cookie-policy-header">
        <LandingHeader />
      </div>


      {/* Page Title */}
      <div className="cookie-policy-title">
        <h1>Cookie Policy</h1>

        <p>
          Last Updated: August 13, 2026
        </p>
      </div>


      {/* Cookie Policy Content */}
      <div className="cookie-policy-content">

        <section>
          <h2>1. Introduction</h2>

          <p>
            This Cookie Policy explains how HMW Communications Private
            Limited ("HMW Communications", "we", "us", or "our") uses
            cookies and similar technologies on our websites and
            services, including QuallyHire AI and NuJobs.
          </p>

          <p>
            This policy should be read together with our Privacy Policy
            and Terms & Conditions.
          </p>
        </section>


        <section>
          <h2>2. What Are Cookies?</h2>

          <p>
            Cookies are small text files that are stored on your device
            when you visit a website. They allow websites to remember
            information about your visit and can help provide a better
            user experience.
          </p>

          <p>
            Cookies may also be used to maintain user sessions, remember
            preferences, understand how websites are used, and support
            security and functionality.
          </p>
        </section>


        <section>
          <h2>3. How We Use Cookies</h2>

          <p>
            We may use cookies and similar technologies for purposes
            including:
          </p>

          <ul>
            <li>
              Maintaining user login and session information.
            </li>

            <li>
              Remembering user preferences and settings.
            </li>

            <li>
              Supporting website and application functionality.
            </li>

            <li>
              Improving the performance and usability of our services.
            </li>

            <li>
              Understanding how users interact with our websites.
            </li>

            <li>
              Supporting security and preventing unauthorized activity.
            </li>

            <li>
              Supporting advertising and analytics where applicable.
            </li>
          </ul>
        </section>


        <section>
          <h2>4. Types of Cookies We May Use</h2>

          <h3>4.1 Essential Cookies</h3>

          <p>
            These cookies are necessary for certain parts of our
            websites and applications to function properly.
          </p>

          <p>
            They may be used for purposes such as authentication,
            maintaining sessions, security, and basic platform
            functionality.
          </p>


          <h3>4.2 Preference Cookies</h3>

          <p>
            Preference cookies may allow our services to remember
            information such as user preferences, settings, or
            previously selected options.
          </p>


          <h3>4.3 Analytics Cookies</h3>

          <p>
            Analytics cookies may help us understand how visitors use
            our websites, such as which pages are visited and how users
            navigate through the site.
          </p>

          <p>
            This information may be used to improve the performance,
            usability, and functionality of our services.
          </p>


          <h3>4.4 Advertising Cookies</h3>

          <p>
            Where advertising services are enabled, cookies or similar
            technologies may be used to support advertising, measure
            advertising performance, or display relevant advertisements.
          </p>

          <p>
            Third-party advertising providers may use their own cookies
            or technologies in accordance with their respective policies.
          </p>
        </section>


        <section>
          <h2>5. Third-Party Cookies</h2>

          <p>
            Some services or technologies provided by third parties may
            place cookies or similar technologies on your device.
          </p>

          <p>
            These third parties may include analytics providers,
            advertising providers, authentication providers, payment
            providers, or other service providers used by our platform.
          </p>

          <p>
            Third-party cookies are controlled by the respective
            third-party providers and may be subject to their own
            privacy and cookie policies.
          </p>
        </section>


        <section>
          <h2>6. Cookies Used for Authentication</h2>

          <p>
            When you sign in to QuallyHire AI or NuJobs, cookies or
            similar technologies may be used to maintain your login
            session and help keep your account secure.
          </p>

          <p>
            Disabling certain essential cookies may prevent some
            account or platform functionality from working correctly.
          </p>
        </section>


        <section>
          <h2>7. Managing Cookies</h2>

          <p>
            Most modern web browsers allow you to control or delete
            cookies through their settings.
          </p>

          <p>
            You may choose to block or delete cookies. However, disabling
            certain cookies may affect the functionality or availability
            of some features of our websites or applications.
          </p>

          <p>
            Browser settings and cookie controls may vary depending on
            the browser and device you use.
          </p>
        </section>


        <section>
          <h2>8. Cookies and Advertising</h2>

          <p>
            NuJobs may display advertisements through third-party
            advertising services.
          </p>

          <p>
            Advertising providers may use cookies or similar technologies
            to measure advertising performance, limit repeated
            advertisements, or provide advertisements based on
            applicable information and settings.
          </p>

          <p>
            The use of advertising cookies is subject to the policies
            and settings of the relevant advertising provider.
          </p>
        </section>


        <section>
          <h2>9. Changes to This Cookie Policy</h2>

          <p>
            We may update this Cookie Policy from time to time to
            reflect changes in our services, technologies, legal
            requirements, or business practices.
          </p>

          <p>
            Any updated version will be posted on this page together
            with a revised "Last Updated" date.
          </p>
        </section>


        <section>
          <h2>10. Contact Us</h2>

          <p>
            If you have questions regarding this Cookie Policy,
            please contact us at:
          </p>

          <div className="cookie-contact">
            <strong>HMW Communications Private Limited</strong>

            <br />

            Email: support@hmwcomm.com

            <br />

            QuallyHire AI / NuJobs
          </div>
        </section>

      </div>


      {/* Website Footer */}
      <Footer />

    </div>
  );
}

export default CookiePolicy;